export const arePrivateNotesAvailable = (notes) => Array.isArray(notes) && notes.every((note) =>
    note && note.healthcareProviderPrivateNoteId > 0 && typeof note.noteText === 'string');

export const getPrivateNotesChanges = (originalNotes, notes) => {
    if (originalNotes === notes) return [];

    const changes = [];
    for (const note of notes) {
        const original = originalNotes.find((item) =>
            item.healthcareProviderPrivateNoteId === note.healthcareProviderPrivateNoteId);
        if (!original || original.noteText !== note.noteText || !!original.isPinned !== !!note.isPinned) {
            const data = {
                healthcareProviderPrivateNoteId: note.healthcareProviderPrivateNoteId || 0,
                noteText: note.noteText.trim(),
                isPinned: !!note.isPinned,
            };
            changes.push({ method: 'saveProviderPrivateNote', key: note.healthcareProviderPrivateNoteId || note.draftId, data, note });
        }
    }
    for (const original of originalNotes) {
        if (!notes.some((note) => note.healthcareProviderPrivateNoteId === original.healthcareProviderPrivateNoteId)) {
            changes.push({
                method: 'deleteProviderPrivateNote',
                key: original.healthcareProviderPrivateNoteId,
                data: { healthcareProviderPrivateNoteId: original.healthcareProviderPrivateNoteId },
            });
        }
    }
    return changes;
};

export const rebasePrivateNotes = (editor, savedNotes, completedKeys) => {
    const completed = new Set(Array.isArray(completedKeys) ? completedKeys : [completedKeys]);
    const pending = getPrivateNotesChanges(editor.originalNotes, editor.notes)
        .filter((change) => !completed.has(change.key));
    return pending.reduce((notes, change) => {
        if (change.method === 'deleteProviderPrivateNote') {
            return notes.filter((note) => note.healthcareProviderPrivateNoteId !== change.key);
        }
        if (!change.data.healthcareProviderPrivateNoteId) return [...notes, change.note];
        if (!notes.some((note) => note.healthcareProviderPrivateNoteId === change.key)) {
            return [...notes, change.note];
        }
        return notes.map((note) => note.healthcareProviderPrivateNoteId === change.key
            ? { ...note, ...change.data, hasUnsavedChanges: true }
            : note);
    }, savedNotes);
};
